<!--
무자료 등록(재고방식) > 라벨출력 안내
------------------------------------
-->
<template>

    <div class="uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-height-1-1">

        <div class="body">
            <div class="uk-text-large3 uk-text-center app-color-black">
                <i class="material-icons" style="font-size: 48px;">info</i>
                무자료 등록이 완료되었습니다
            </div>
            <div class="uk-text-large uk-text-center uk-margin-bottom app-color-black">
                보관라벨 출력 후 무자료 박스(상품)을 보관하세요
            </div>

            <div class="uk-text-large4 uk-text-center uk-margin-bottom uk-text-primary" title="보관장소">
                {{ box.storage }}
            </div>

            <div class="uk-text-center uk-margin-large-bottom">
                <button
                    type="button"
                    class="uk-button uk-button-white uk-button-large uk-margin-right"
                    title="보관장소를 수동으로 입력합니다"
                    @click="$refs.storage.form()"
                >
                    <i class="material-icons">edit</i>
                    보관장소 직접작성
                </button>

                <button
                    v-if="this.regionCode !== 2"

                    type="button"
                    class="uk-button uk-button-white uk-button-large"
                    title="보관장소를 랜덤으로 발행합니다"
                    @click="$refs['random-storage'].form()"
                >
                    <i class="material-icons">border_outer</i>
                    보관장소 랜덤작성
                </button>

                <!-- 보관장소 수정 컴포넌트 -->
                <update-storage
                    ref="storage"

                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    :box="box"
                    :prods="prods"
                ></update-storage>
                <update-random-storage
                    ref="random-storage"

                    :csrf-token="csrfToken"
                    :region-id="regionId"
                    :box="box"
                    :prods="prods"
                ></update-random-storage>
            </div>

            <div class="uk-text-center">
                <button
                    type="button"
                    class="uk-button uk-button-primary uk-button-large"
                    @click="printStoreLabel(arguments, firstProdId)"
                    title="현재 상품의 보관라벨을 출력합니다"
                >
                    <i class="material-icons" style="font-size: 48px; vertical-align: middle">print</i>
                    <span class="text">PRINT STORE-LABEL (보관라벨)</span>
                </button>
            </div>
        </div>

        <div class="uk-margin-top uk-text-center">
            <button
                v-if="this.regionCode !== 2"
                type="button"
                class="uk-button uk-button-large uk-button-gray uk-margin-large-right"
                @click="back"
            >
                <i class="material-icons">arrow_back</i>
                뒤로
            </button>
            <button
                type="button"
                class="uk-button uk-button-large uk-button-primary"
                @click="done"
            >
                <i class="material-icons">check</i>
                완료
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'update-storage': require('./update-storage.vue').default,
            'update-random-storage': require('./update-random-storage.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,

            /**
             * 지역코드
             * (미국 커스텀때문에 추가됨)
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },

            /**
             * (object) 박스정보
             * {
             *     tracking_no,
             *     user_id,
             *     name_prefix,
             * }
             */
            box: {
                type: Object,
            },

            /**
             * 등록된 상품정보 배열
             */
            prods: {
                type: Array,
            },
        },
        data: function () {
            return {

            };
        },
        computed: {
            /**
             * 첫번째 상품ID
             * @return int
             */
            firstProdId() {
                if (this.prods[0]) {
                    return this.prods[0].id;
                }
                return null;
            },
        },
        methods: {
            /**
             * 뒤로처리
             */
            back() {
                // 이벤트 발생
                this.$emit('back');
            },
            /**
             * 완료처리
             */
            done() {
                // 이벤트 발생
                this.$emit('done');
            },

            /**
             * 보관라벨 출력
             * @param args
             * @param prod_id
             */
            printStoreLabel(args, prod_id) {
                //console.log(prod_id);
                $.app.print.store_label(args, prod_id);
            }
        },


    }
</script>

<style lang="scss" scoped>
    .body {
        width: 90%;
        background-color: #fff;
        border: 1px solid #999;
        padding: 5rem;
    }

</style>